export enum Counties
{
    US = 'US'
}
export default Counties;


// WEBPACK FOOTER //
// ./src/types/enums/Counties.ts